import { PlacesType } from 'react-tooltip';
import { HOVER_TOOLTIP_ID } from 'src/constants';
import { HoverTooltip } from '../HoverTooltip';
import { useId } from 'react';

interface SpanWithHoverTooltipProps {
  className?: string;
  children: React.ReactNode;
  tooltipId?: string;
  tooltipContent: string;
  tooltipPlace?: PlacesType;
}

export const SpanWithHoverTooltip = ({
  className,
  children,
  tooltipId,
  tooltipContent,
  tooltipPlace,
}: SpanWithHoverTooltipProps) => {
  const id = useId();
  const preparedTooltipId = tooltipId || `${HOVER_TOOLTIP_ID}-${id}`;

  return (
    <>
      {tooltipContent && <HoverTooltip id={preparedTooltipId} />}

      <span
        className={className}
        color="transparent"
        data-tooltip-id={tooltipContent ? preparedTooltipId : undefined}
        data-tooltip-content={tooltipContent}
        data-tooltip-place={tooltipPlace}
      >
        {children}
      </span>
    </>
  );
};
